import React from "react";
import { motion } from "framer-motion";
import { Link } from "react-router-dom";

// Import videos and image from assets
import icechestwaterImage from "../assets/icechestwater.jpg";
import solonetVideo from "../assets/solonet.mp4";
import timberImage from "../assets/timber.jpg";

const ventures = [
  {
    name: "Ice Chest Water",
    slug: "ice-chest-water",
    description:
      "A premium natural mineral water brand known for its purity, sustainability, and refined taste redefining hydration with elegance.",
    type: "image",
    media: icechestwaterImage,
  },
  {
    name: "Solonet Properties",
    slug: "solonet-properties",
    description:
      "A real estate development company crafting luxurious and smart living spaces that blend innovation with comfort.",
    type: "video",
    media: solonetVideo,
  },
  {
    name: "Global Timber Limited",
    slug: "global-timber-limited",
    description:
      "A timber company that exports timber worldwide, committed to sustainable forestry and quality products.",
    type: "image",
    media: timberImage,
  },
];

const BusinessPortfolio = () => {
  return (
    <section id="ventures" className="bg-[#0a0a0a] text-white py-24 px-6 md:px-20">
      <div className="max-w-7xl mx-auto text-center mb-16">
        <motion.h2
          initial={{ opacity: 0, y: -20 }}
          whileInView={{ opacity: 1, y: 0 }}
          transition={{ duration: 1 }}
          viewport={{ once: true }}
          className="text-4xl md:text-5xl font-playfair text-[#d4af37]"
        >
          Business Ventures
        </motion.h2>

        <motion.p
          initial={{ opacity: 0, y: 10 }}
          whileInView={{ opacity: 1, y: 0 }}
          transition={{ duration: 1, delay: 0.3 }}
          viewport={{ once: true }}
          className="text-gray-400 mt-4 max-w-2xl mx-auto"
        >
          A portfolio of excellence where vision meets innovation.
          Discover the ventures shaping industries and communities under Kwame O. Sarfo’s leadership.
        </motion.p>
      </div>

      {/* Venture Cards */}
      <div className="grid md:grid-cols-3 gap-10 max-w-7xl mx-auto">
        {ventures.map((venture) => (
          <motion.div
            key={venture.slug}
            initial={{ opacity: 0, y: 40 }}
            whileInView={{ opacity: 1, y: 0 }}
            transition={{ duration: 1, delay: 0.2 }}
            viewport={{ once: true }}
            className="bg-[#111] rounded-2xl overflow-hidden shadow-lg hover:shadow-[#d4af37]/20 transition-all duration-300"
          >
            <Link to={`/ventures/${venture.slug}`}>
              <div className="h-60 w-full overflow-hidden">
                {venture.type === "video" ? (
                  <video
                    src={venture.media}
                    autoPlay
                    loop
                    muted
                    playsInline
                    alt={`Video showcasing ${venture.name}`}
                    className="w-full h-full object-cover hover:scale-105 transition-transform duration-500"
                  />
                ) : (
                  <img
                    src={venture.media}
                    alt={`${venture.name} - ${venture.description}`}
                    className="w-full h-full object-cover hover:scale-105 transition-transform duration-500"
                  />
                )}
              </div>
              <div className="p-6 text-left">
                <h3 className="text-2xl font-playfair text-[#d4af37] mb-3 hover:text-yellow-500 transition-colors">
                  {venture.name}
                </h3>
                <p className="text-gray-400 leading-relaxed">{venture.description}</p>
              </div>
            </Link>
          </motion.div>
        ))}
      </div>
    </section>
  );
};

export default BusinessPortfolio;
